module.exports = __webpack_public_path__ + "img/feature-plan.ba9be89c.png";